export const Logo = ({ size = "md" }) => {
  const sizes = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-3xl sm:text-4xl",
  };
  return (
    <span
      className={`font-mono font-semibold tracking-tight ${sizes[size]} select-none`}
      data-testid="brand-logo"
    >
      <span className="text-sky-400">&lt;</span>
      <span className="text-white">Divelopers</span>
      <span className="text-orange-500">/</span>
      <span className="text-sky-400">&gt;</span>
    </span>
  );
};

export default Logo;
